import { theme } from "../../theme";
export const eventList = {
    wrapper: {
      fontFamily: theme.typography.fontFamily,
    },
    cardItem: {
      boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.05)",
      borderRadius: "6px",
      height: "100%",
      cursor: "pointer",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#fff",

      "&:hover": {
        borderColor: theme.palette.primary.main,
      },
    },
    cardContentItem: {
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
      lineHeight: 1,
    },
    icon: {
      marginRight: "12px",
      color: "#A8A8A8",
    },
    eventLogo: {
      width: "50px",
      height: "50px",
    },
    cardContent: {
      display: "flex",
      paddingTop: "25px",
      paddingBottom: "25px !important",
      paddingLeft: "25px",
      paddingRight: "25px",
    },
    attendeesIcon: {
      position: "relative",
      top: "3px",
      marginRight: "7px",
      color: theme.palette.text.primary,
      fontSize: "16px",
    },
  } as const;